import { API_TYPE } from './api';
import umuWebview from '@umu/umu-webview';
import alert from '../common/components/modalDialog/alert';
import IPlainData from '../interface/plainData';
import { getLangText } from '../services/langService';

function getLoginUrl(): string {
    return '/globaluser/loginpage?from_url=' + encodeURIComponent(window.location.href);
}

// todo 使用外部fetch library
export function postData(url: string, data: IPlainData) {
    // Default options are marked with *
    return window
        .fetch(url, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, same-origin, *omit
            headers: {
                'user-agent': 'Mozilla/4.0 MDN Example',
                'content-type': 'application/json',
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then((response) => {
            return handleResponse(response.json());
        })
        .catch(() => {
            console.error('fetch error');
        });
}

// todo 使用外部fetch library
export function postFormData(url: string, data: FormData) {
    return window
        .fetch(url, {
            body: data, // must match 'Content-Type' header
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, same-origin, *omit
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then((response) => {
            return handleResponse(response.json());
        })
        .catch(() => {
            console.error('fetch error');
        });
}

export function getData(url: string, data: IPlainData) {
    let payloadUrl = url;
    const queryParams: string[] = [];
    if (data) {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const value = data[key];
                queryParams.push(`${key}=${value}`);
            }
        }
        if (queryParams.length > 0) {
            payloadUrl = `${payloadUrl}?${queryParams.join('&')}`;
        }
    }
    return window
        .fetch(payloadUrl, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, same-origin, *omit
            headers: {
                'user-agent': 'Mozilla/4.0 MDN Example',
                'content-type': 'application/json',
            },
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        })
        .then((response) => {
            return handleResponse(response.json());
        })
        .catch(() => {
            console.error('fetch error');
            return Promise.resolve({});
        });
}

// 处理response中特定的错误信息
export function handleResponse(response: any) {
    return response.then((res: any) => {
        const errorCode = res.error_code || res.errNo || res.errno || res.err_no;
        if (errorCode) {
            //识别错误码并通知APP 20000：未登录 20200：不在ip白名单中
            if (errorCode === 20200) {
                if (umuWebview.UA_INFO.isUMUWebview) {
                    umuWebview.callHandler('sendFailMsgToApp', res);
                }
                alert({
                    title: getLangText('提示'),
                    content: res.error_message,
                    btnConfirmText: getLangText('确认'),
                    submitBtnClick: () => {
                        window.location.href = getLoginUrl();
                    },
                });
            }
            return res;
        } else {
            return res;
        }
    });
}

export function fetchData(url: string, type: API_TYPE, data: IPlainData | FormData) {
    if (type === API_TYPE.GET) {
        return getData(url, data);
    } else if (type === API_TYPE.POST) {
        return postData(url, data);
    }

    return Promise.reject();
}
